"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Drop = require("grommet/es6/components/Drop");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var fadeIn = (0, _styledComponents.keyframes)(["from{opacity:0;}to{opacity:1;}"]);

var fadeInTime = function fadeInTime(props) {
  if (props.fadeInTime) {
    return props.fadeInTime;
  }

  return '0.5s';
};

var alignArrow = function alignArrow(align) {
  var top;
  var bottom;
  var borderWidth;

  if (align.top) {
    borderWidth = '0px 7px 7px';

    if (align.top === 'bottom') {
      top = '-7px;';
    }
  }

  if (align.bottom) {
    borderWidth = '7px 7px 0px';

    if (align.bottom === 'top') {
      bottom = '-7px';
    }
  }

  var right;
  var left;

  if (align.right) {
    if (align.right === 'right') {
      right = '10px';
    }
  }

  if (align.left) {
    if (align.left === 'left') {
      left = '10px';
    }
  }

  return "\n    top: ".concat(top, ";\n    bottom: ").concat(bottom, ";\n    border-width: ").concat(borderWidth, ";\n    left: ").concat(left, ";\n    right: ").concat(right, ";\n  ");
};

var alignShadow = function alignShadow(align) {
  var boxShadow = 'rgb(166, 166, 166) 1px 4px 6px -2px';

  if (align.bottom) {
    if (align.bottom === 'top') {
      boxShadow = 'rgb(166, 166, 166) 1px -4px 6px -2px';
    }
  }

  return "\n    box-shadow: ".concat(boxShadow, ";\n  ");
};

var ExtendedDrop = (0, _styledComponents["default"])(_Drop.Drop).withConfig({
  displayName: "Tooltip__ExtendedDrop",
  componentId: "sc-1kj1fiy-0"
})([""]);

var T = _styledComponents["default"].div.withConfig({
  displayName: "Tooltip__T",
  componentId: "sc-1kj1fiy-1"
})(["animation:", " ", " linear;padding:10px;position:relative;border:#adb3b8 solid 1px;", " z-index:1;background:#fff;&::before{content:\"\";position:absolute;", ";border-style:solid;border-color:#adb3b8 transparent;display:block;width:0;z-index:0;}"], fadeIn, function (props) {
  return fadeInTime(props);
}, function (props) {
  return alignShadow(props.align);
}, function (props) {
  return alignArrow(props.align);
});

var OuterDiv = _styledComponents["default"].div.withConfig({
  displayName: "Tooltip__OuterDiv",
  componentId: "sc-1kj1fiy-2"
})(["padding:10px;"]);

var Tooltip = function Tooltip(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var align = props.align,
      target = props.target,
      delay = props.delay,
      rest = _objectWithoutProperties(props, ["align", "target", "delay"]);

  (0, _react.useEffect)(function () {
    var timeout = setTimeout(function () {
      setShow(true);
    }, delay || 1);
    return function () {
      clearTimeout(timeout);
    };
  }, []);

  if (!show) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null);
  }

  return /*#__PURE__*/_react["default"].createElement(ExtendedDrop, {
    align: align,
    target: target,
    overflow: "visible",
    plain: true,
    stretch: false
  }, /*#__PURE__*/_react["default"].createElement(OuterDiv, null, /*#__PURE__*/_react["default"].createElement(T, _extends({
    align: align
  }, rest))));
};

var _default = Tooltip;
exports["default"] = _default;